import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const STATS = [
  {
    num: "0",
    unit: "prompts",
    desc: "복잡한 작업은 뒤에서 처리됩니다. 프롬프트 엔지니어링은 필요 없습니다.",
  },
  {
    num: "6",
    unit: "categories",
    desc: "Voice, TTS, 음악, 이미지, 영상, 커뮤니티 — 모든 AI 창작 도구가 한 곳에.",
  },
  {
    num: "∞",
    unit: "outputs",
    desc: "아이디어 하나로 음성, 이미지, 영상까지 끝없이 만들어낼 수 있습니다.",
  },
];

const FEATURES = [
  "복잡한 작업은 뒤에서 처리",
  "프롬프트 엔지니어링 불필요",
  "Voice, 이미지, 영상까지 한 워크스페이스",
  "크리에이터·브랜드·작은 팀을 위해",
];

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#0a0a0a",
    padding: "96px 32px",
    "@media (max-width:600px)": { padding: "64px 24px" },
  },
  inner: {
    maxWidth: 1280,
    margin: "0 auto",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 96,
    alignItems: "center",
    "@media (max-width:900px)": { gridTemplateColumns: "1fr", gap: 48 },
  },
  miniLabel: {
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    color: "#555",
    marginBottom: 16,
  },
  headline: {
    fontSize: 40,
    fontWeight: 700,
    letterSpacing: "-1.5px",
    lineHeight: 1.15,
    color: "#fff",
    margin: 0,
    marginBottom: 48,
    "@media (max-width:600px)": { fontSize: 30 },
  },
  statList: { borderTop: "1px solid #1e1e1e" },
  statRow: {
    display: "flex",
    alignItems: "center",
    gap: 24,
    padding: "24px 0",
    borderBottom: "1px solid #1e1e1e",
    "@media (max-width:600px)": {
      gap: 14,
      padding: "20px 0",
      flexWrap: "wrap",
    },
  },
  statNum: {
    fontSize: 48,
    fontWeight: 700,
    letterSpacing: "-2px",
    color: theme.palette.primary.main,
    lineHeight: 1,
    minWidth: 80,
    "@media (max-width:600px)": { fontSize: 36, minWidth: 56 },
  },
  statUnit: {
    fontSize: 14,
    fontWeight: 600,
    color: "#444",
    minWidth: 70,
    "@media (max-width:600px)": { minWidth: 0 },
  },
  statDesc: {
    fontSize: 14,
    lineHeight: 1.6,
    color: "#888",
    flex: 1,
  },
  /* right */
  panel: {
    background: "#111",
    border: "1px solid #1e1e1e",
    borderRadius: 16,
    padding: 40,
    "@media (max-width:600px)": { padding: 24 },
  },
  panelIcon: {
    width: 40,
    height: 40,
    borderRadius: 8,
    background: theme.palette.primary.main,
    color: "#0a0a0a",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 20,
  },
  panelTitle: {
    fontSize: 22,
    fontWeight: 700,
    color: "#fff",
    letterSpacing: "-0.4px",
    lineHeight: 1.25,
    margin: 0,
    marginBottom: 24,
  },
  featList: { borderTop: "1px solid #1e1e1e" },
  featRow: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    padding: "14px 0",
    borderBottom: "1px solid #1e1e1e",
    fontSize: 14,
    color: "#bbb",
    lineHeight: 1.5,
  },
  check: {
    width: 20,
    height: 20,
    borderRadius: "50%",
    background: "#1e1e1e",
    border: `1px solid ${theme.palette.primary.main}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 11,
    color: theme.palette.primary.main,
    flexShrink: 0,
  },
}));

export default function WhySoriSori() {
  const classes = useStyles();
  return (
    <Box component="section" className={classes.root}>
      <Box className={classes.inner}>
        <Box>
          <Typography className={classes.miniLabel}>Why SoriSori AI</Typography>
          <Typography component="h2" className={classes.headline}>
            The AI does the hard work.
            <br />
            You get the content.
          </Typography>
          <Box className={classes.statList}>
            {STATS.map((s) => (
              <Box key={s.unit} className={classes.statRow}>
                <span className={classes.statNum}>{s.num}</span>
                <span className={classes.statUnit}>{s.unit}</span>
                <span className={classes.statDesc}>{s.desc}</span>
              </Box>
            ))}
          </Box>
        </Box>

        <Box className={classes.panel}>
          <Box className={classes.panelIcon}>🖋</Box>
          <Typography className={classes.panelTitle}>
            Designed for humans,
            <br />
            powered by AI.
          </Typography>
          <Box className={classes.featList}>
            {FEATURES.map((f) => (
              <Box key={f} className={classes.featRow}>
                <span className={classes.check}>✓</span>
                <span>{f}</span>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
